import { createRoot } from 'react-dom/client';
import ReactModal from 'react-modal';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import Root from 'screens/Root';
import { LicenseManager } from 'ag-grid-enterprise';

import { benLabs } from '../package.json';
import getEnvironment from '../src/getEnvironment';
import '../src/scss/main.scss';

LicenseManager.setLicenseKey(benLabs?.agGridLicenseKey);

const { host } = window.location;
const environment = getEnvironment(host);
if (environment !== 'local') {
  Sentry.init({
    dsn:
      'https://5391fc0feb0b5334e87c08e3909d4f52@o138492.ingest.us.sentry.io/4509001394225152',
    release: process.env.REACT_APP_VERSION,
    environment,
    integrations: [new BrowserTracing()],
    tracesSampleRate: 0.2,
  });
}

ReactModal.setAppElement('#root');

const root = createRoot(document.getElementById('root'));
root.render(<Root environment={environment} />);
